import { render, staticRenderFns } from "./PackingPositionLightUp.vue?vue&type=template&id=6898f326"
import script from "./PackingPositionLightUp.vue?vue&type=script&lang=js"
export * from "./PackingPositionLightUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports